module.exports = function() {
  return new Worker(__webpack_public_path__ + "9f5e8fbfcc7085b3054b.worker.js");
};